import { useState } from "react";
import { changeLanguage, translation } from "../../helper/translation"
import { activeSiteLogoProposal } from "../../model/logoProposals"
import at from '../../assets/images/austria_flag.png';
import uk from '../../assets/images/uk_flag.png';
import tr from '../../assets/images/turkey_flag.png';

export const Header = () => {

    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuVisible(!mobileMenuVisible);
        const mobileMenu = document.getElementById('nav');
        if(mobileMenuVisible){
            mobileMenu?.classList.remove("show-mobile-menu");
        }
        else{
            mobileMenu?.classList.add("show-mobile-menu");
        }
    }

    return(
        <header className="header-area header-sticky">
            <div className="container">
                
                <div className="col-12">
                    <nav className="main-nav">
                        <div className="">
                            {/* <!-- ***** Logo Start ***** --> */}
                            <a href="/" className="logo zi999">
                                <img
                                    src={activeSiteLogoProposal.src}
                                    alt="enginkaya.com"
                                    className={activeSiteLogoProposal.wordmark ? "logo-wordmark" : undefined}
                                />
                                
                            </a>
                        </div>
                        {/* <!-- ***** Logo End ***** -->
                        
                        <!-- ***** Menu Start ***** --> */}
                        <div className="">
                            <ul id="nav" className="nav">
                                <li><a href="/" className="active">{translation("home")}</a></li>
                                <li><a href="/about-engin-kaya">{translation("about-me")}</a></li>
                                {/* <li className="has-sub">
                                    <a href="javascript:void(0)">Photos &amp; Videos</a>
                                    <ul className="sub-menu">
                                        <li><a href="contests.html">Contests</a></li>
                                        <li><a href="contest-details.html">Single Contest</a></li>
                                    </ul>
                                </li> */}
                                <li><a href="/projects">{translation("projects")}</a></li>
                                <li><a href="/studio">{translation("studio")}</a></li>
                                <li><a href="/contact">{translation("contact")}</a></li>
                            </ul>
                        </div>
                        <div className="">
                            <a className='menu-trigger' onClick={() => toggleMobileMenu()}>
                                <span>Menu</span>
                            </a>
                            <ul className="language">
                                <li className="float-start">
                                    <button
                                        type="button"
                                        className="border-0 bg-transparent p-0"
                                        onClick={() => changeLanguage("de")}
                                    >
                                        <img src={at} className="image-w-25" alt={translation("Deutsch")}  />
                                    </button>
                                </li>
                                <li className="float-start">
                                    <button
                                        type="button"
                                        className="border-0 bg-transparent p-0"
                                        onClick={() => changeLanguage("en")}
                                    >
                                        <img src={uk} className="image-w-25" alt={translation("English")}  />
                                    </button>
                                </li>
                                <li className="float-start">
                                    <button
                                        type="button"
                                        className="border-0 bg-transparent p-0"
                                        onClick={() => changeLanguage("tr")} 
                                    >
                                        <img src={tr} className="image-w-25" alt={translation("Türkce")} />
                                    </button>
                                </li>
                            </ul>
                        </div>
                        {/* <!-- ***** Menu End ***** --> */}
                    </nav>
                </div>
            </div>
        </header>
    )
}